import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)); }, []);
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-slateink">The Studio Journal</h1>
        <p className="text-slate-600 mt-4 text-lg">Gift ideas, how-tos and inspiration for the people you love.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group card-hover block rounded-2xl overflow-hidden bg-white border border-slate-100">
            <div className="aspect-[16/10] overflow-hidden bg-subtle">
              <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-5">
              <div className="flex gap-2 flex-wrap mb-2">{(p.tags || []).map((t) => <span key={t} className="text-[10px] font-semibold uppercase tracking-wide text-amber-700 bg-amber-100 rounded-full px-2 py-0.5">{t}</span>)}</div>
              <h3 className="font-display text-lg font-bold text-slateink leading-tight">{p.title}</h3>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{p.excerpt}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
